
import React, { useState } from 'react';
import { Card } from "@/components/ui/card";
import { Client } from './data/clientTypes';

interface ClientLogoProps {
  client: Client;
  className?: string;
}

const ClientLogo: React.FC<ClientLogoProps> = ({ client, className }) => {
  const [imageError, setImageError] = useState(false);

  // Function to handle image loading errors
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error(`Error loading image: ${client.logoPath}`);
    e.currentTarget.src = "https://via.placeholder.com/200x100?text=Logo+No+Disponible";
    setImageError(true);
  };

  // Check if this is the Special ticket logo that needs color inversion
  const isSpecialTicketLogo = client.logoPath === "/lovable-uploads/3778eca8-796f-4293-b513-70a6044faaf7.png";

  return (
    <Card className={`p-2 flex items-center justify-center shadow-sm hover:shadow-md transition-all ${className || ''}`}>
      <div className="w-full h-14 flex items-center justify-center">
        <img
          src={client.logoPath}
          alt={client.altText}
          className={`max-h-12 max-w-[90%] object-contain transition-all duration-200 ${isSpecialTicketLogo ? 'invert' : ''}`}
          onError={handleImageError}
          loading="lazy" decoding="async"
          onLoad={() => console.log(`Successfully loaded: ${client.name} - ${client.logoPath}`)}
        />
      </div>
    </Card>
  );
};

export default ClientLogo;
